import { reduxForm } from 'redux-form';
import Component from './BlockSubMerchantForm';

const validate = (values) => {
  const errors = {};
  if (!values.reason) {
    errors.reason = 'Alasan harus Dipilih';
  }
  if (values.reason === 'other' && !values.otherReason) {
    errors.otherReason = 'Wajib diisi';
  }
  return errors;
};

const BlockSubMerchantForm = reduxForm({
  form: 'BlockSubMerchantForm',
  initialValues: {
    reason: '',
    otherReason: ''
  },
  validate
})(Component);

export default BlockSubMerchantForm;
